import { useState } from "react";
import { flashMessage } from "../../../utils/flash";
import { IoCloudUploadOutline } from "react-icons/io5";
import { useSelector } from "react-redux";

const FileUploaderHandler = ({ submit, sectionTitle = "", label, fileId }) => {
  const { isLoading, isMigrated, migration } = useSelector(
    (state) => state.migration
  );

  const [selectedFile, setSelectedFile] = useState(null);
  const [filename, setfilename] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    if (file) {
      setfilename(file.name);
    }
  };

  return (
    <div className='px-3 mb-3 migration'>
      <h4 className='mt-4'>{sectionTitle}</h4>
      <div className='mb-4'>
        <div className='file-input '>
          <label htmlFor={`file-${fileId}`} className='form-label w-100'>
            <input
              type='file'
              id={`file-${fileId}`}
              name={fileId}
              style={{
                visibility: "hidden",
                height: "0",
              }}
              accept='.csv'
              onChange={handleFileChange}
            />
            <span className='d-block'>{label}</span>
            <div
              className='custom-file-upload border d-flex justify-content-center align-items-center py-1 border-dotted mt-0 rounded cursor-p'
              style={{ borderBottom: "2px dotted #234111 !important" }}
            >
              <div className={`${filename && "mt-2"}`}>
                <IoCloudUploadOutline size={22} className='me-2' />{" "}
                <span>Browse Document</span>
                {filename && <p className='text-primary'>{filename}</p>}
              </div>
            </div>
          </label>
        </div>
        <button
          className='btn btn-sm btn-primary'
          style={{ marginTop: "18px" }}
          onClick={() => {
            if (selectedFile) {
              submit(selectedFile);
              return;
            }
            flashMessage("error", "Please select a file");
          }}
          disabled={isLoading}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default FileUploaderHandler;
